import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { ExternalLink } from 'lucide-react';
import { useIntl } from 'react-intl';

type OpenMapInMapsLinkProps = {
  href: string;
};

export const OpenMapInMapsLink = ({ href }: OpenMapInMapsLinkProps) => {
  const { formatMessage } = useIntl();

  return (
    <Flex
      direction='column'
      align='center'
      justify='center'
      gap={3}
      px={4}
      py={6}
      h='100%'
      w='100%'
      bg='gray.100'
      textAlign='center'
    >
      <Text fontSize='sm' color='gray.600'>
        {formatMessage({
          id: 'locationMap.shortLinkHelp',
          defaultMessage: 'Short share links cannot be shown inline. Open the map in a new tab.',
        })}
      </Text>
      <Link
        href={href}
        isExternal
        display='inline-flex'
        alignItems='center'
        gap={2}
        color='blue.600'
        fontWeight='semibold'
        fontSize='sm'
        aria-label={formatMessage({
          id: 'locationMap.openInGoogleMapsAria',
          defaultMessage: 'Open location in Google Maps in a new window',
        })}
        _hover={{
          color: 'blue.700',
          textDecoration: 'underline',
        }}
        _active={{ color: 'blue.800' }}
        _focusVisible={{ boxShadow: 'outline' }}
      >
        {formatMessage({
          id: 'locationMap.openInGoogleMaps',
          defaultMessage: 'Open in Google Maps',
        })}
        <Icon as={ExternalLink} boxSize={4} color='currentColor' aria-hidden />
      </Link>
    </Flex>
  );
};
